import React, { useEffect, useRef, useState } from "react";

import { Fade, Modal as ModalMUI } from "@mui/material";
import { Typography } from "@mui/material";

import { Close } from "@mui/icons-material"

import styles from "./Modal.module.scss";
import Button from "components/Button/Button";

// Tallas del modal. `size` controla SOLO el ancho.
//   sm  -> 420px   1 a 3 campos cortos
//   md  -> 640px   una columna, o 4-5 campos
//   lg  -> 900px   dos columnas, o con mapa
//   xl  -> 1200px  vistas con tabla adentro
//   fit ->   0     lo define el contenido
const CLASE_POR_TAMANIO = {
    sm: styles.paperSm,
    md: styles.paperMd,
    lg: styles.paperLg,
    xl: styles.paperXl,
    fit: styles.paperFit,
};

export default function Modal({
    children,
    title,
    confirmationModal = false,
    onClose = () => { },
    open,
    close = true,
    compact = false,
    narrow = false,
    fit = false,
    // API nueva. Si viene, gana sobre los booleanos de ancho (compact/narrow/fit).
    // Los booleanos siguen funcionando para no tocar los ~50 call sites de una: se
    // migran de a uno pasando `size` en su lugar.
    // Ojo: `compact` ademas achica el titulo y el separador. Eso es DENSIDAD, no
    // ancho, asi que sigue valiendo aunque se pase `size`.
    size,
}) {
    const [isOpen, setIsOpen] = useState(false);
    const [confirmationModalOpen, setConfirmationModalOpen] = useState(false);

    // Keep showing the last content while the close animation plays,
    // instead of switching to empty/differently-sized content the instant the caller clears its state.
    const lastContentRef = useRef({ children, title, compact, narrow, fit, size });
    if (open) {
        lastContentRef.current = { children, title, compact, narrow, fit, size };
    }
    const { children: displayChildren, title: displayTitle, compact: displayCompact, narrow: displayNarrow, fit: displayFit, size: displaySize } = lastContentRef.current;

    const claseAncho = displaySize
        ? CLASE_POR_TAMANIO[displaySize] ?? ""
        : [
            displayCompact ? styles.paperCompact : "",
            displayNarrow ? styles.paperNarrow : "",
            displayFit ? styles.paperFit : "",
        ].filter(Boolean).join(" ");

    useEffect(() => {
        setIsOpen(open)
    }, [open])

    useEffect(() => {
        const handleKeyUp = ({ key }) => {
            if (key === "Escape") {
                setConfirmationModalOpen(true);
            }
        };

        isOpen && window.addEventListener("keyup", handleKeyUp);

        return () => {
            window.removeEventListener("keyup", handleKeyUp);
        };
    }, [isOpen]);

    const handleCloseModal = () => {
        if (confirmationModal) {
            setConfirmationModalOpen(true)
            return;
        }
        setIsOpen(false)
        onClose();
    };

    return (
        <>
            <ModalMUI
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                className={styles.modal}
                open={isOpen}
            >
                <Fade in={isOpen} className={styles.modal}>
                    <div className={styles.modal}>
                        <div className={`${styles.paper} ${claseAncho}`}>
                            <Typography
                                variant="h6"
                                fontWeight={100}
                                className={displayCompact ? `${styles.title} ${styles.titleCompact}` : styles.title}
                                style={{
                                    color: displayTitle?.toLowerCase().includes("eliminar")
                                        ? "#f00"
                                        : "",
                                }}
                            >
                                {displayTitle}
                            </Typography>
                            <hr className={displayCompact ? `${styles.hr} ${styles.hrCompact}` : styles.hr} />
                            {close && <Close
                                className={styles.closeButton}
                                onClick={handleCloseModal}
                                role="button"
                            />}
                            {displayChildren}
                        </div>
                    </div>
                </Fade>
            </ModalMUI>

            {confirmationModal && confirmationModalOpen && (
                <ModalMUI
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    className={styles.confirmationModal}
                    open={isOpen}
                >
                    <Fade in={isOpen} className={styles.modal}>
                        <div className={styles.confirmationModal}>
                            <div className={styles.paper}>
                                ¿Estás seguro que deseás cancelar?
                                <br />
                                Perderás todos los cambios establecidos
                                <Button
                                    onClick={(e) => {
                                        e.preventDefault();
                                        setConfirmationModalOpen(false);
                                        setIsOpen(false);
                                        onClose();
                                    }}
                                >
                                    <span>Sí</span>
                                </Button>
                                <Button
                                    onClick={(e) => {
                                        e.preventDefault();
                                        setConfirmationModalOpen(false);
                                    }}
                                >
                                    <span>No</span>
                                </Button>
                            </div>
                        </div>
                    </Fade>
                </ModalMUI>
            )}
        </>
    );
}
